import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';

import { BodyContainer } from '../delivery-fees-modal/styled';

import { IDonationsModalProps } from './types';

/**
 *
 * DonationsModal purpose: to display a modal with
 * more information regarding Donations.
 *
 */
const DonationsModal: FC<IDonationsModalProps> = ({
  isOpen,
  onCloseCallback,
  title,
  modalAppearanceEventMessage,
  children,
}) => {
  const { formatMessage } = useIntl();
  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      data-testid="tims-camps-donation-modal"
      heading={title}
      bodyComponent={<BodyContainer>{children}</BodyContainer>}
      actions={
        <Box margin="1rem" minWidth="auto" width="100%">
          <ActionButton onlyIcon fullWidth onClick={onCloseCallback}>
            {formatMessage({
              id: 'okayButtonText',
            })}
          </ActionButton>
        </Box>
      }
      modalAppearanceEventMessage={modalAppearanceEventMessage}
      showCloseButton
      onDismiss={onCloseCallback}
    />
  );
};

export default DonationsModal;
